<template>
  <form v-if="form" @submit.prevent="submit" @keydown="form.onKeydown($event)">
    <alert-error
      v-if="form.errors.get('message')"
      :form="form"
      :message="form.errors.get('message')"
    ></alert-error>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div
                  class="row d-flex align-items-center justify-content-center"
                >
                  <div class="col-md-8">
                    <div class="form-group">
                      <label for="nom"
                        >Nom chantier <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('nom'),
                        }"
                        id="nom"
                        v-model="form.nom"
                        type="text"
                        placeholder="Nom"
                        maxlength="100"
                      />
                      <has-error :form="form" field="nom"></has-error>
                    </div>
                  </div>
                  <div
                    class="col-md-2 d-flex align-items-center justify-content-center"
                  >
                    <switches
                      text-enabled="Statut actif"
                      text-disabled="Statut inactif"
                      v-model="form.statut"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                  <div
                    class="col-md-2 d-flex align-items-center justify-content-center"
                  >
                    <switches
                      text-enabled="Récurrent"
                      text-disabled="Non récurrent"
                      v-model="form.recurrence"
                      type-bold="true"
                      color="custom-primary"
                      class="ml-1 mb-0 font-size-17"
                    ></switches>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="code_chantier">Code chantier </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('code_chantier'),
                        }"
                        id="code_chantier"
                        v-model="form.code_chantier"
                        type="code_chantier"
                        placeholder="Code chantier"
                        maxlength="100"
                      />
                      <has-error :form="form" field="code_chantier"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="societe">Société </label>
                      <v-custom-select
                        label="nom"
                        id="societe"
                        :options="societes"
                        :reduce="(societe) => societe.uuid"
                        v-model="form.societe"
                        placeholder="Choisir la société"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="type"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('societe'),
                        }"
                      />
                      <has-error :form="form" field="societe"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="client">Client </label>
                      <v-custom-select
                        label="nom"
                        id="client"
                        :options="clients"
                        :reduce="(client) => client.uuid"
                        v-model="form.client"
                        placeholder="Choisir le client"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('client'),
                        }"
                      />
                      <has-error :form="form" field="client"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="commercial">Commercial </label>
                      <v-custom-select
                        label="nom"
                        id="commercial"
                        :options="commerciaux"
                        :reduce="(commercial) => commercial.uuid"
                        v-model="form.commercial"
                        placeholder="Choisir un commercial"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('commercial'),
                        }"
                      />
                      <has-error :form="form" field="commercial"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="inspecteur">Inspecteur </label>
                      <v-custom-select
                        label="nom"
                        id="inspecteur"
                        :options="inspecteurs"
                        :reduce="(inspecteur) => inspecteur.uuid"
                        v-model="form.inspecteur"
                        placeholder="Choisir un inspecteur"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('inspecteur'),
                        }"
                      />
                      <has-error :form="form" field="inspecteur"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="montant">Montant </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('montant'),
                        }"
                        id="montant"
                        v-model.number="form.montant"
                        type="text"
                        placeholder="Montant"
                        maxlength="50"
                      />
                      <has-error :form="form" field="montant"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="periodicite"
                        >Périodicité
                        <span v-if="form.recurrence" class="text-danger"
                          >*</span
                        ></label
                      >
                      <v-custom-select
                        label="nom"
                        id="periodicite"
                        :options="periodicites"
                        :reduce="(periodicite) => periodicite.uuid"
                        v-model="form.periodicite"
                        placeholder="Périodicité"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('periodicite'),
                        }"
                      />
                      <has-error :form="form" field="periodicite"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="telephone">Téléphone </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('telephone'),
                        }"
                        id="telephone"
                        v-model="form.telephone"
                        type="text"
                        placeholder="Téléphone"
                        maxlength="20"
                      />
                      <has-error :form="form" field="telephone"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row pt-3">
                  <div class="col-md-12 col-lg-12 mt-n1">
                    <div class="form-group">
                      <label for="adresse">Adresse </label>
                      <textarea
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('adresse'),
                        }"
                        id="adresse"
                        v-model="form.adresse"
                        type="text"
                        placeholder="Adresse"
                        maxlength="100"
                      ></textarea>
                      <has-error :form="form" field="adresse"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n1">
                    <div class="form-group">
                      <label for="code_postal">Code postal </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('code_postal'),
                        }"
                        id="code_postal"
                        v-model="form.code_postal"
                        type="text"
                        placeholder="Code postal"
                        maxlength="20"
                      />
                      <has-error :form="form" field="code_postal"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4 mt-n1">
                    <div class="form-group">
                      <label for="ville">Ville </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('ville'),
                        }"
                        id="ville"
                        v-model="form.ville"
                        type="text"
                        placeholder="Ville"
                        maxlength="50"
                      />
                      <has-error :form="form" field="ville"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4 mt-n1">
                    <div class="form-group">
                      <label for="pays">Pays </label>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('pays'),
                        }"
                        id="pays"
                        v-model="form.pays"
                        type="text"
                        placeholder="Pays"
                        maxlength="50"
                      />
                      <has-error :form="form" field="pays"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2 mb-4">
      <div class="col-md-12 text-right">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="list"
          v-if="!edit"
        >
          Liste des chantiers
        </button>

        <ButtonLoader
          :busy="form.busy"
          type="submit"
          customClass="btn btn-custom-primary w-40"
          loadText="Traitement en cours..."
          :Text="edit ? 'Enrégistrer' : 'Créer'"
          style="min-width: 100px"
        ></ButtonLoader>
      </div>
    </div>
  </form>
</template>

<script>
// import DatePicker from 'vue2-datepicker';
// import { VueEditor } from 'vue2-editor';
// import VueEditorToolbar from '@/vue-editor-tool-bar';

export default {
  props: {
    propForm: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    commerciaux: {
      type: Array,
      default() {
        return [];
      },
    },
    clients: {
      type: Array,
      default() {
        return [];
      },
    },
    societes: {
      type: Array,
      default() {
        return [];
      },
    },
    periodicites: {
      type: Array,
      default() {
        return [];
      },
    },
    inspecteurs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: null,
      // VueEditorToolbar,
    };
  },
  components: {
    // DatePicker,
    // VueEditor,
  },

  methods: {
    /**
     * Modal note
     */

    init() {
      this.form = this.propForm;
    },
    submit() {
      this.$emit('submit', this.form);
    },
    list() {
      this.$emit('goList');
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
